import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import DateInput from "../../../../components/DateInput";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { sxLabel, sxValidationMessage } from "./sxProps";
import dayjs from "dayjs";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";

interface Props {
  onDateChange: (value: { dataInicio: string; dataFim: string }) => void;
	onGerarRelatorioClick: (value: {dataInicio: string; dataFim: string }) => void;
}

interface Errors {
  dataInicio?: string;
  dataFim?: string;
}

const RelatorioReembolsoForm: React.FC<Props> = ({ onDateChange, onGerarRelatorioClick }) => {
  const { textStyleAccessibility } = useAccessibility();

  const [dataInicio, setDataInicio] = useState<string>("");
  const [dataFim, setDataFim] = useState<string>("");
  const [errors, setErrors] = useState<Errors>({});

	const isButtonEnabled = dataInicio && dataFim && !errors.dataInicio && !errors.dataFim;

	useEffect(() => {
		if (isButtonEnabled) {
			onDateChange({ dataInicio, dataFim });
		}
	}, [isButtonEnabled, onDateChange, dataFim, dataInicio]);

  const handleDateChange = (field: "dataInicio" | "dataFim", newDate: Date | null) => {
    const formattedDate = newDate ? dayjs(newDate).format("DD/MM/YYYY") : "";
    if (field === "dataInicio") {
      setDataInicio(formattedDate);
    } else {
      setDataFim(formattedDate);
    }
  };

	const handleGerarRelatorioClick = () => {
		onGerarRelatorioClick({ dataInicio, dataFim });
	}

  return (
    <div className="relatorio-reembolso-form-container">
      <div>
        <Typography style={textStyleAccessibility} sx={sxLabel}>
          Data início
        </Typography>

        <DateInput
          label={`Data início ${errors.dataInicio ?? ''}`}
          slotProps={{
            textField: {
              placeholder: "01/01/2000",
              error: !!errors.dataInicio,
            },
          }}
          onChange={(newDate) => handleDateChange("dataInicio", newDate)}
					maxDate={dayjs()}
					onError={(err) => {
						setErrors((prevErrors) => {
							if (!err) return { ...prevErrors, dataInicio: '' };
							if (err === "maxDate") return { ...prevErrors, dataInicio: 'Data início deve ser menor que a data atual.' };
							if (err === "invalidDate") return { ...prevErrors, dataInicio: 'Data inválida.' };
							return prevErrors;
						});
					}}
        />
				<div className="container-validation-message" style={{ minHeight: "24px" }}>
					{errors.dataInicio && (
							<Typography sx={sxValidationMessage} style={textStyleAccessibility}>
								{errors.dataInicio}
							</Typography>
					)}
				</div>
      </div>

      <div>
        <Typography style={textStyleAccessibility} sx={sxLabel}>
          Data fim
        </Typography>

        <DateInput
          label={`Data fim ${errors.dataFim ?? ''}`}
          slotProps={{
            textField: {
              placeholder: "01/01/2000",
              error: !!errors.dataFim,
            },
          }}
          onChange={(newDate) => handleDateChange("dataFim", newDate)}
					maxDate={dayjs()}
					minDate={dataInicio ? dayjs(dataInicio, "DD/MM/YYYY") : undefined}
					onError={(err) => {
						setErrors((prevErrors) => {
							if (!err) return { ...prevErrors, dataFim: '' };
							if (err === "maxDate") return { ...prevErrors, dataFim: 'Data fim deve ser menor que a data atual.' };
							if (err === "minDate") return { ...prevErrors, dataFim: 'Data fim deve ser maior que a Data início.' };
							if (err === "invalidDate") return { ...prevErrors, dataFim: 'Data inválida.' };
							return prevErrors;
						});
					}}
        />
				<div className="container-validation-message" style={{ minHeight: "24px" }}>
					{errors.dataFim && (
						<Typography sx={sxValidationMessage} style={textStyleAccessibility}>
							{errors.dataFim}
						</Typography>
					)}
				</div>
      </div>

      <DefaultButton 
				text="Gerar relatório" 
				onClick={() => handleGerarRelatorioClick()}
				disabled={!isButtonEnabled}
				// style={{ marginTop: '24px'}}
			/>
    </div>
  );
};

export default RelatorioReembolsoForm;
